import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    paddingTop: designTokens.spacing[3],
    paddingBottom: designTokens.spacing[3],
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[4],
    position: "relative",
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
    minHeight: "200px",
    boxSizing: "border-box",
    ":hover": {
      ...shorthands.borderColor(designTokens.neutral[200]),
      boxShadow: designTokens.shadow.base,
    },
    ":focus-within": {
      ...shorthands.borderColor(designTokens.accent[500]),
      boxShadow: designTokens.shadow.base,
    },
  },
  activeBadge: {
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.medium,
    color: designTokens.accent[600],
    backgroundColor: designTokens.accent[50],
    paddingTop: designTokens.spacing[1],
    paddingBottom: designTokens.spacing[1],
    paddingLeft: designTokens.spacing[2],
    paddingRight: designTokens.spacing[2],
    ...shorthands.borderRadius(designTokens.borderRadius.full),
  },
  cardInner: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  cardArchived: {
    ...shorthands.border("2px", "dashed", designTokens.neutral[200]),
    opacity: 0.7,
  },
  titleSection: {
    height: designTokens.spacing[12],
  },
  title: {
    fontWeight: designTokens.fontWeight.bold,
    fontSize: designTokens.fontSize.base,
    color: designTokens.neutral[900],
    lineHeight: designTokens.lineHeight.tight,
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    overflow: "hidden",
    minWidth: 0,
  },
  titleText: {
    flex: 1,
    minWidth: 0,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  archivedLockIcon: {
    marginLeft: designTokens.spacing[2],
    opacity: 0.6,
  },
  moreButton: {
    color: designTokens.neutral[600],
    ":hover": {
      color: designTokens.neutral[600],
    },
  },
  content: {
    marginTop: designTokens.spacing[4],
    marginBottom: 0,
    flex: 1,
    minHeight: designTokens.card.fixedDescriptionMinHeight,
  },
  iconRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    marginTop: "auto",
    flexShrink: 0,
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: designTokens.neutral[100],
    paddingTop: designTokens.spacing[2],
  },
  iconButton: {
    fontSize: designTokens.fontSize.xl,
    color: designTokens.neutral[600],
  },
  descriptionText: {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
    color: designTokens.neutral[500],
    fontSize: designTokens.fontSize.sm,
    fontFamily: designTokens.fontFamily,
    lineHeight: designTokens.lineHeight.normal,
  },
  playButton: {
    position: "absolute",
    bottom: designTokens.spacing[3],
    right: designTokens.spacing[4],
  },
});
